import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { Outlet } from "react-router-dom";
import AppBar from "@mui/material/AppBar";

export default function Root() {
    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar position="fixed" color="secondary">
                <Toolbar>
                    <Typography variant="h6" noWrap component="div">
                        Optimized Network Engine (O.N.E) | By Mordah
                    </Typography>
                </Toolbar>
            </AppBar>

            <main style={{ padding: "85px 15px 30px 15px" }}>
                <Outlet />
            </main>
        </Box>
    );
}
